import { registerPopupAuto } from "@/features/application/popup-auto/PopupAuto"
import { useAppStateStore } from "@/features/application/state/useAppStateStore"
import { TypesContextesAutorisesEnum } from "@/features/auth/context-app/types/ContextApp"
import { useVersionCGUStore } from "./useVersionCGUStore"
import { useAfficheCGUStore } from "./useAfficheCGUStore"

export function registerPopupAutoCGU() {
  registerPopupAuto({
    key: "CGU",
    canPopup: async () => {
      // Ne pas poper si pas de rattachement
      const appState = useAppStateStore()
      if (appState.contextCourant === TypesContextesAutorisesEnum.Aucun) return false

      // Ne pas poper si cgu déja validées
      const versionStore = useVersionCGUStore()
      const estVersionExpirée = await versionStore.checkCguExpirées()
      return estVersionExpirée
    },
    showPopup: () => {
      const dialogCGU = useAfficheCGUStore()
      return dialogCGU.showDialog({ validationObligatoire: true }).then(() => {
        const versionStore = useVersionCGUStore()
        return versionStore.setCguValidées()
      })
    }
  })
}
